var React = require('react');

function TrianglesEarlySvgMobile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M86.1445 372.312L68.4741 271.512M86.1445 372.312L34.627 326.65M86.1445 372.312L-24.5346 314.874M68.4741 271.512L34.627 326.65M68.4741 271.512L-24.5346 314.874M34.627 326.65L-24.5346 314.874","stroke":"#FF9EB6","key":0}),React.createElement("path",{"d":"M367.725 21.6992L318.234 6.40287M367.725 21.6992L335.266 34.3742M367.725 21.6992L316.31 58.3116M318.234 6.40287L335.266 34.3742M318.234 6.40287L316.31 58.3116M335.266 34.3742L316.31 58.3116","stroke":"#FF9EB6","key":1})]);
}

TrianglesEarlySvgMobile.defaultProps = {"width":"360","height":"377","viewBox":"0 0 360 377","fill":"none"};

module.exports = TrianglesEarlySvgMobile;

TrianglesEarlySvgMobile.default = TrianglesEarlySvgMobile;
